import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { selectPaymentState } from '../../core/selectors/paymentState';
import { ModalService } from './modal.service';
import { UnpaidComponent } from '../../billing-module/components/unpaid/unpaid.component';
import { filter, map, take, startWith, delay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PaymentStatusRequested } from '../../core/actions/paymentStatus';

@Injectable()
export class PaymentGuard implements CanActivate, CanActivateChild, OnDestroy {
  sub;

  constructor(
    private store: Store<fromRoot.State>,
    private modalService: ModalService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const unitId = +localStorage.getItem('unit_id');
    if (unitId) {
      this.store.dispatch(new PaymentStatusRequested(unitId));
    }
    return this.store.select(selectPaymentState).pipe(
      filter(payment => payment.status !== null),
      map(payment => {
        if (
          (payment.status && payment.status === 'canceled') ||
          payment.status === 'unpaid'
        ) {
          this.modalService.appendComponentToBody(UnpaidComponent, null);
        }
        return (
          payment &&
          (payment.status === 'trialing' ||
            payment.status === 'active' ||
            payment.status === 'always_active' ||
            payment.status === 'pending')
        );
      }),
      take(1)
    );
  }

  canActivateChild() {
    return this.canActivate();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
